<template>
  <transition name="mdlanim">
    <div v-if="$root.modalState.show" class="modal">
        <span @click='closeModal' class="close">&times;</span>
        <Slider :imagelist="$root.modalState.imagelist"></Slider>
        <div id="caption">{{ $root.modalState.caption }}</div>
    </div>
  </transition>
</template>

<script>
import Slider from './Slider'

export default {
  components: {
    Slider
  },
  mounted () {},
  methods: {
    closeModal () {
      this.$root.modalState.show = false
    }
  }
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

.modal {
  position: fixed;
  z-index: 1000000;
  padding-top: 40pt;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
}

.mdlanim-enter, .mdlanim-leave-to {
  opacity: 0;
}

.mdlanim-enter-active, .mdlanim-leave-active {
  transition: opacity ease-in .25s;
}

.modal .modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

.modal #caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  font-size: 30pt;
  padding: 10px 0;
  height: 40pt;
}

.modal .modal-content,
.modal #caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.modal .close {
  position: absolute;
  top: 10px;
  right: 1em;
  color: #f1f1f1;
  font-size: 30pt;
  font-family: Lato;
  font-weight: bold;
  transition: 0.3s;
}

.modal .close:hover,
.modal .close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

@media only screen and (max-width: 700px) {
  .modal .modal-content {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue